var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminMembersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 12.5855 0.579463 11.229 1.61091 10.2288C2.64236 9.22857 4.04131 8.66667 5.5 8.66667C6.95869 8.66667 8.35764 9.22857 9.38909 10.2288C10.4205 11.229 11 12.5855 11 14H9.625C9.625 12.9391 9.1904 11.9217 8.41682 11.1716C7.64323 10.4214 6.59402 10 5.5 10C4.40598 10 3.35677 10.4214 2.58318 11.1716C1.8096 11.9217 1.375 12.9391 1.375 14H0ZM5.5 8C3.22094 8 1.375 6.21 1.375 4C1.375 1.79 3.22094 0 5.5 0C7.77906 0 9.625 1.79 9.625 4C9.625 6.21 7.77906 8 5.5 8ZM5.5 6.66667C7.01937 6.66667 8.25 5.47333 8.25 4C8.25 2.52667 7.01937 1.33333 5.5 1.33333C3.98062 1.33333 2.75 2.52667 2.75 4C2.75 5.47333 3.98062 6.66667 5.5 6.66667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminMembersIcon);
export default __webpack_public_path__ + "static/media/AdminMembersIcon.fb3dd3a0978a4073b02690fa98270d93.svg";
export { ForwardRef as ReactComponent };